import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import { FluentProvider, Spinner } from '@fluentui/react-components';
import './i18n';
import { getTheme } from './helpers/getTheme';

const rootElement: HTMLElement | null = document.getElementById('container');
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  const theme = getTheme();

  root?.render(
    <FluentProvider theme={theme}>
      <React.Suspense fallback={<Spinner />}>
        <App />
      </React.Suspense>
    </FluentProvider>,
  );
});
